import { SELECIONAR_AGENCIA } from '../types';

export default function selecionarCidade (data) {
  return {
    type: SELECIONAR_AGENCIA,
    payload: data
  }
}
